export default "/assets/images/performance-filter-img-01.c0970d383c8197d1.webp";